<style>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">公司名称</div>
          <el-select size="mini" class="ipt-sty" @change="handleChangeCompany" v-model="page.tenantGuid" placeholder="请选择"
            filterable>
            <el-option v-for="(item, index) in sendTenantList" :key="index" :label="item.sendTenantName"
              :value="item.sendTenantGuid"></el-option> </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">选择部门</div>
          <el-select clearable size="mini" class="ipt-sty" @change="handleChangeOrg" v-model="page.organisationGuid"
            filterable placeholder="请选择部门">
            <el-option v-for="(item, index) in organisationList" :key="index" :label="item.organisationName"
              :value="item.guid"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">提交人员</div>
          <el-input clearable v-model="page.applyStaffName" size="mini" class="ipt-sty" placeholder="请输入提交人"></el-input>
        </el-col>

        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">提交时间</div>
          <el-date-picker clearable size="mini" class="ipt-sty" v-model="timeRange" type="daterange" align="center"
            unlink-panels range-separator="-" start-placeholder="起始时间" end-placeholder="截止时间" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">停线原因</div>
          <el-select clearable size="mini" class="ipt-sty" v-model="page.lineStopRuleGuid" filterable
            placeholder="请选择停线原因">
            <el-option v-for="item in reasonList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" v-if="isNeedApprove">
          <div class="search-area-div">审批状态</div>
          <el-select size="mini" v-model="page.approveState" filterable placeholder="请选择审批状态" class="ipt-sty">
            <el-option v-for="item in approvalStateList" :key="item.value" :label="item.label"
              :value="item.value"></el-option> </el-select>
        </el-col>
      </el-row>
    </div>
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'" style="border-radius:6px;">
      <div class="button-area">
        <el-button size="mini" v-if="isNeedApprove" type="info" @click="toBatchAudit">批量审核</el-button>
        <el-button size="mini" type="info" @click="exportFile">批量导出</el-button>
      </div>
      <el-table :data="tableData" :height="tableHeight" @selection-change="handleSelectionChange" stripe border style="width: 100%" v-loading="tableLoading">
        <el-table-column
          type="selection"
          width="60"
          header-align="center"
          align="center"
          :selectable="selected"
        ></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="tenantName" show-overflow-tooltip width="240" label="公司名称" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="staffName" show-overflow-tooltip width="80" label="提交人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.applyStaffName || '-' }}</template>
        </el-table-column>
        <!-- 审批状态 -->
        <el-table-column prop="approveState" width="80" label="审批状态" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- N 初始 A 审批中 Y 已通过 R 驳回 C 已撤销 -->
              <a class="reject-btn btn" v-if="scope.row.bizApproveVO&&scope.row.bizApproveVO.approveState == 'R'">已驳回</a>
              <a class="pass-btn btn" v-if="!scope.row.bizApproveVO">已通过</a>
              <a class="pass-btn btn" v-if="scope.row.bizApproveVO&&scope.row.bizApproveVO.approveState == 'Y'">已通过</a>
              <a class="ing-btn btn" v-if="scope.row.bizApproveVO&&scope.row.bizApproveVO.approveState == 'A'">审批中</a>
              <a class="cancel-btn btn" v-if="scope.row.bizApproveVO&&scope.row.bizApproveVO.approveState == 'N'">草稿中</a>
              <a class="cancel-btn btn" v-if="scope.row.bizApproveVO&&scope.row.bizApproveVO.approveState == 'C'">已撤销</a>
          </template>
        </el-table-column>
        <el-table-column prop="organisationName" show-overflow-tooltip width="120" label="所在部门" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="positionName" show-overflow-tooltip width="120" label="所在岗位" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.positionName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="inputDate" width="150" show-overflow-tooltip label="提交时间" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.inputTime | getTimeDate }} </template>
        </el-table-column>
        <el-table-column prop="inputDate" width="290"  label="停线/回补时间" header-align="center"
          align="left">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark"  placement="right-end">
              <div slot="content">
                <div style="padding-bottom:4px;" v-for="(item,index) in formatLineDetail(scope.row.lineStopApplyDetails,1)" :key="index">{{item  }}</div>
              </div>
              <span>{{formatLineDetail(scope.row.lineStopApplyDetails,0)}}</span>
            </el-tooltip>
            
           </template>
        </el-table-column>
        <el-table-column prop="inputDate" width="100" show-overflow-tooltip label="停线原因" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.stopReason }}</template>
        </el-table-column>
        <el-table-column prop="inputDate" width="100" show-overflow-tooltip label="具体原因" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.stopReasonDefinite }} </template>
        </el-table-column>

        <el-table-column prop="bank" min-width="190px" label="操作" header-align="center" align="center" fixed="right">
            <template slot-scope="scope">
              <a class="txt-color" @click="seePics(scope.row.attaches)">查看图片｜</a>
              <a class="txt-color" v-if="!isNeedApprove&&!scope.row.bizApproveVO" @click="delVacation(scope.row.guid)">删除｜</a>
              <a class="txt-color" v-if="!isNeedApprove&&!scope.row.bizApproveVO" @click="toEdit(scope.row.guid)">编辑｜</a>
              <a class="txt-color"
                v-if="scope.row.bizApproveVO && scope.row.bizApproveVO.approveState == 'A' && scope.row.bizApproveVO.approveStaffGuids.indexOf(staffGuid) > -1"
                @click="passDialogVisible = true; approveSuggest = ''; form = scope.row;">通过｜</a>
              <a class="txt-color"
                v-if="scope.row.bizApproveVO && scope.row.bizApproveVO.approveState == 'A' && scope.row.bizApproveVO.approveStaffGuids.indexOf(staffGuid) > -1"
                @click="rejectDialogVisible = true; approveSuggest = ''; form = scope.row;">驳回｜</a>
              <a class="txt-color" @click="toDeal(scope.row)">详情</a>
            </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" maxlength="100" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" maxlength="100" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量审核" :visible.sync="dialogBatch" width="30%" top="15%" :close-on-click-modal="false">
      <div class="batch-radio">
        <div class="batch-radio-title"><span style="color:red;">*</span>审核类型：</div>
        <el-radio v-model="batchRadio" label="Y">通过</el-radio>
        <el-radio v-model="batchRadio" label="N">驳回</el-radio>
      </div>
      <el-input type="textarea" :rows="5" placeholder="请填写审核原因" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toSubmitAudit()">确定</el-button>
      </span>
    </el-dialog>
    <el-image-viewer v-if="showViewer" :on-close="() => {
      showViewer = false;
    }
      " :url-list="srcLists" />
  </div>
</template>

<script>
export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      contentMainHeight: window.innerHeight - 200,
      tableHeight: window.innerHeight - 263,
      fullscreenLoading: false,
      reasonList: [],
      approvalStateList: [
        {
          label: '全部',
          value: '-1'
        },

        {
          label: '审批中',
          value: 'A'
        }, {
          label: '已通过',
          value: 'Y'

        }, {
          label: '已驳回',
          value: 'R'

        },
        {
          label: '已撤销',
          value: 'C'

        }],
      tenantList: [],
      organisationList: [],
      timeRange: '',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        organisationGuid: '',
        applyStartTime: '',
        applyEndTime: '',
        applyStaffName: '',
        lineStopRuleGuid: '',
        applyStaffName: "",
        approveState: '-1',
      },
      tableLoading: false,
      right: 'right',
      tableData: [],
      sendTenantList: [],
      srcLists: [],
      showViewer: false,
      reasonList: [],
      isNeedApprove: false,
      rejectDialogVisible: false,
      passDialogVisible: false,
      approveSuggest: null,
      form: null,
      staffGuid: userinfo.staffGuid,
      batchRadio:null,
      dialogBatch:false,
      multipleSelection:[],
    };
  },
  created() {
    this.getSendTenantList();
  },
  activated(){
    this.getList();
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 310;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  methods: {
    formatLineDetail(lineStopApplyDetails, type) {
      if (!lineStopApplyDetails) return '-';
      let newArr = [];
      if (type == 0) {
        newArr.push('停线时间：' + lineStopApplyDetails[0].stopTime + ' 回补时间：' + (lineStopApplyDetails[0].amendTime||'-'))
        return newArr.join();
      }
      if (type == 1) {
        lineStopApplyDetails.forEach(item => {
          newArr.push('停线时间：' + item.stopTime + ' 回补时间：' + (item.amendTime||'-' ))
        })
        return newArr;
      }
 

    },
    transformCodeToName(value) {
      let name = '-'
      this.reasonList && this.reasonList.forEach(item => {
        if (item.value == value) {
          name = item.name;
        }
      })
      return name;
    },
    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data;
            self.page.tenantGuid = self.sendTenantList[0].sendTenantGuid;
            this.isTenantNeedApprove(self.sendTenantList[0].sendTenantGuid);
            self.getReasonList();
            self.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    search() {
      let self = this;
      self.tableLoading = true;
      self.page.pageIndex = 1;
      if (self.timeRange && self.timeRange.length != 0) {
        self.page.applyStartTime = self.timeRange[0] + ' ' + '00:00:00';
        self.page.applyEndTime = self.timeRange[1] + ' ' + '23:59:59';
      } else {
        self.page.applyStartTime = null;
        self.page.applyEndTime = null;
      }
      let req = JSON.parse(JSON.stringify(this.page));
      if (req.approveState == '-1') {
        req.approveState = null;
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/line-stop-apply/list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages || 0;
          self.page.totalRows = res.data.data.totalRows || 0;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getList() {
      let self = this;
      let req = JSON.parse(JSON.stringify(this.page));
      if (req.approveState == '-1') {
        req.approveState = null;
      }
      if(!this.page.tenantGuid) return;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/line-stop-apply/list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages || 0;
          self.page.totalRows = res.data.data.totalRows || 0;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleChangeCompany(v) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
        sendTenantGuid: localStorage.guid,
      };
      this.isTenantNeedApprove(v);
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
          self.getReasonList();
        }
      });
    },
    handleChangeOrg() {
      self.getReasonList();
    },
    delVersion(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/delete?guid=${guid}`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: this.sendTenantList[0].sendTenantGuid,
        organisationGuid: '',
        applyStartTime: '',
        applyEndTime: '',
        applyStaffName: '',
        lineStopRuleGuid: '',
        approveState: '-1',
      };
      this.handleChangeCompany(this.sendTenantList[0].sendTenantGuid);
      this.timeRange = [];
      this.getList();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    delVacation(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msSalesPerformService}/line-stop-apply/del`, [guid])
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                self.page.pageIndex = 1;
                self.getList(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        });
    },
    seePics(srcList) {
      console.log(srcList)
      if (!srcList) {
        this.$message.error('暂无图片');
        return;
      }
      this.srcLists = [];
      srcList.forEach((item) => {
        this.srcLists.push(item.path);
      });
      this.$forceUpdate();
      this.showViewer = true;
    },
    toEdit(guid) {
      this.$router.push({
        path: '/lineStopEdit',
        query: {
          productGuid: this.$route.query.productGuid,
          guid: guid
        }
      })
    },
    toDeal(obj) {
      if (obj.bizApproveVO) {
        this.$router.push({
          path: '/lineStopDetail',
          query: {
            productGuid: this.$route.query.productGuid,
            guid: obj.guid,
            bizApproveVO: JSON.stringify(obj.bizApproveVO),
            isNeedApprove:this.isNeedApprove?1:0
          }
        })
      } else {
        this.$router.push({
          path: '/lineStopDetail',
          query: {
            productGuid: this.$route.query.productGuid,
            guid: obj.guid,
            isNeedApprove:this.isNeedApprove?1:0
          }
        })
      }


    },
    exportFile() {
      let req = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: this.page.tenantGuid,
      }
      this.fullscreenLoading = true;
      this.api.postJsonD(`/${serverConfig.msSalesPerformService}/line-stop-apply/export`, req).then((res) => {
        this.fullscreenLoading = false;
        let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        let fileName = '停线一览表-' + this.$moment(new Date()).format('YYYYMMDD');
        let objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a')
        link.download = fileName;
        link.href = objectUrl;
        link.click();
      });
    },
    getReasonList() {
      let req = {
        tenantGuid: this.page.tenantGuid,
        organisationGuid: this.page.organisationGuid,
        pageIndex: 1,
        pageSize: -1
      }
      this.api.postJson(
        `/${serverConfig.msConfigureService}/line-stop-rule/list`, req).then((resp) => {
          let data = resp.data.data.records;
          console.log(data)
          this.reasonList = [];
          if (!data) return;
          data.forEach(item => {
            this.reasonList.push({
              label: item.stopReason,
              value: item.guid
            })
          })
        })
    },
    isTenantNeedApprove(tenantGuid) {
      let req = {
        flowOperationType: 1,
        functionCode: 'TXSQ',
        tenantGuid,
      }
      this.api.get(`/${serverConfig.msConfigureService}/function-workflow/data/get-flow-template-guid`, req).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data && res.data.data.guid) {
            this.isNeedApprove = true;
          } else {
            this.isNeedApprove = false;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //驳回提交
    toRejectSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.form.bizApproveVO.approveGuid,
        flowType: '00024',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid
      };
      this.fullscreenLoading = true;

      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success('驳回成功！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //通过
    toPassSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        guid: this.form.bizApproveVO.approveGuid,
        flowType: '00024',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.$message.success('审批通过！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    selected(row, index) {
      console.log(row);
      if (row.bizApproveVO&&row.bizApproveVO.approveState =='A'&&row.bizApproveVO.approveStaffGuids.indexOf(this.staffGuid)>-1) {
        return true 
      } else {
        return false; 
      }
    },
    handleSelectionChange(val){
      let self = this;
      self.multipleSelection = [];
      val.forEach(item =>{
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.bizApproveVO.approveGuid);
      });

    },
       //批量审核
    toSubmitAudit(){
      let self = this;
      if(!self.batchRadio){
        self.$message.error("请选择审批类型！");
        return;
      }
      if(self.batchRadio == 'N' && (!self.approveSuggest || self.approveSuggest == '') ){
        self.$message.error("请填写审核理由！");
        return;
      }
      let query = {
        approveType:self.batchRadio == 'Y'?'通过':'驳回',
        guids:this.multipleSelection,
        approveSuggest:self.approveSuggest,
        approveStaffGuid:self.staffGuid
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/batch-approve`, query).then(
        (res)=> {
          this.fullscreenLoading = false;
          if ((res.data.code == serverConfig.REQUIRE_SUCCESS_CODE)) {
            this.$message.success("审批成功！");
            this.getList();
            this.dialogBatch = false;
            this.batchRadio = '';
            this.multipleSelection = [];
            this.approveSuggest = ''
          }else{
            this.$message.error(res.data.msg);
          }
        }
      );
    },
    //批量审核
    toBatchAudit(){
      if(this.multipleSelection.length == 0){
        this.$message.error("请先勾选数据");
        return;
      }
      this.batchRadio = null;
      this.approveSuggest = null;
      this.dialogBatch = true;
    },

  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.button-area {
  display: flex;
}

.reject-btn.btn {
    background: #FFF2F4;
    border: 1px solid rgba(255, 219, 224, 1);
    border-radius: 2px;
    color: #FB2323;
    font-size: 12px;
    width: 44px;
    height: 22px;
    display: inline-block;

}

.pass-btn.btn {
    background: #F2FFF5;
    border: 1px solid rgba(220, 250, 228, 1);
    border-radius: 2px;
    color: #1BA854;
    font-size: 12px;
    width: 44px;
    height: 22px;
    display: inline-block;
}

.ing-btn.btn {
    background: #FFFBF2;
    border: 1px solid rgba(255, 241, 212, 1);
    border-radius: 2px;
    color: #FF991C;
    font-size: 12px;
    width: 44px;
    height: 22px;
    display: inline-block;
}

.cancel-btn.btn {
    background: #F5F5F5;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    color: #666;
    font-size: 12px;
    width: 44px;
    height: 22px;
    display: inline-block;
}
.batch-radio{
  display: flex;
  align-items: center;
  text-align: left;
  margin-bottom: 20px;
}
.batch-radio-title{
  flex-shrink: 0;
  margin-right: 10px;
}
</style>